import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { AdGroupIdColumn as AdGroupIdColumnConfig } from '@bingads-webui-campaign/ad-groups-data';

export class AdGroupIdColumn extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    super({
      ...AdGroupIdColumnConfig,
      title: i18n.getString('ColumnName_AdGroupId'),
      sortable: 'Id',
      type: 'number',
    });
  }
}
